import type { MaybeRef } from 'vue';

export const getMyOtpCodeQueryKey = ['get-my-otp-code'];
export const getMyWalletsQueryKey = ['get-my-wallets'];
export const getUserByWalletAddressQueryKey = (
  address: MaybeRef<string | undefined>,
) => ['get-user-by-wallet-address', address];
